var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"container"}},[_c('phone2action-widget',{attrs:{"id":"widget"}}),_c('help-box')],1),_c('div',{attrs:{"id":"footer"}},[_c('span',[_vm._v(_vm._s(_vm.copyrightText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }